// Import the fetchData function (adjust the path to your actual utility file)
import { fetchData } from "../../common/api-service"; // or wherever fetchData is defined

// Gate Web APIs
export const getCount = (token) => fetchData("gate/web/count", token);
export const getPurposeApi = (token) =>
  fetchData("gate/web/purpose_based_count", token);
export const getEntryBasedApi = (token) =>
  fetchData("gate/web/entry_based_count", token);
export const getOverstayCountApi = (token) =>
  fetchData("gate/web/overstayed_count", token);
export const getCourierCountApi = (token) =>
  fetchData("gate/web/courier_status_based_count", token);
export const getRegisterCountApi = (token) =>
  fetchData("gate/web/meeting_based_count", token);
export const getMonthlyCountApi = (token) =>
  fetchData("gate/web/monthly/web", token);
export const getTodayCountApi = (token) => fetchData("gate/web/today", token);
export const getAverageApi = (token) =>
  fetchData("gate/web/average_gate_in", token);

// Gate Visitors APIs
export const getLiveCountApi = (token) =>
  fetchData("gate/visitors/live_count", token);
export const getHistoryCountApi = (token) =>
  fetchData("gate/visitors/history", token);
export const getEntryCountApi = (token) =>
  fetchData("gate/visitors/entry_based", token);
export const getRegistrationCountApi = (token) =>
  fetchData("gate/visitors/registration_based", token);
export const getLocationCountApi = (token) =>
  fetchData("gate/visitors/location_based", token);
export const getGateCountApi = (token) =>
  fetchData("gate/visitors/gate_based", token);
export const getDepartmentCountApi = (token) =>
  fetchData("gate/visitors/department_based", token);
export const getOrganizationCountApi = (token) =>
  fetchData("gate/visitors/organization_based", token);
export const getPurposeCountApi = (token) =>
  fetchData("gate/visitors/purpose_based", token);
export const getMeetingPersonCountApi = (token) =>
  fetchData("gate/visitors/meeting_person_based", token);
